import {Page, Pages, PracticeData} from "@/libwyze-shared/types";
import {StringUtil} from "@/shared/string_util";
import {$KTS, KeyTextStrings} from "@/shared/types";
import {getMemberAuth} from "@/shared/auth";
import {MailTemplateId} from "@/libwyze-common/api/types";
import {BaseEmailCampaignFragment, Email} from "./BaseEmailCampaignFragment";
import React, {ReactElement} from "react";
import {Typography} from "@mui/material";
import {MessageCampaignConfig, MessageCampaignConfigType} from "../BaseMessageCampaignFragment";
import {FestivalEmailCampaignCustomizeOptions, FestivalEmailCampaignTemplate} from "@/vantage-shared/types";

export class FestivalEmailCampaignFragment extends BaseEmailCampaignFragment<FestivalEmailCampaignCustomizeOptions> {

  private readonly memberAuth = getMemberAuth();

  protected createCampaignConfig(): MessageCampaignConfig {
    return {
      name: "Festival",
      type: MessageCampaignConfigType.EMAIL,
      email: {
        title: "Send festival email",
        text: "Send personalized festival emails to your patients. With more than a dozen festivals supported, it's easy to stay in touch with your patients. Simply configure the kind of message you would like to send from our collection of templates, and we'll automatically send it out at the right time.",
        subject: "Seasons Greetings!",
        replaceStrings: new KeyTextStrings([
          $KTS("PRACTICE_NAME", Pages.getInstance().getListItem(PracticeData.provider().practiceId).practicePageProfile.basicInfo.name),
          $KTS("PATIENT_NAME", this.memberAuth.member.user.firstname),
        ]),
        templateId: MailTemplateId.VANTAGE_CAMPAIGNS_FESTIVAL,
      }
    };
  }

  protected async fetchOnMount(forceReload?: boolean): Promise<any> {
    await super.fetchOnMount(forceReload);
    this.setState({
      customizeOptions: await FestivalEmailCampaignCustomizeOptions.load(PracticeData.shared().practiceId),
    });
  }

  private replaceEmailTemplatePlaceholders(emailHtml: string, template: FestivalEmailCampaignTemplate, practiceName: string): Email {
    return {
      subject: "Seasons Greetings!",
      body: StringUtil.replacePlaceholders(emailHtml, ...this.campaignConfig.email.replaceStrings.values),
    }
  }

  protected async generateMessage(practicePage: Page): Promise<Email> {
    const template = this.state.customizeOptions.template;
    if (!template.type) {
      return null;
    }
    return this.replaceEmailTemplatePlaceholders("<html><body>Placeholder</body></html>", template, practicePage.practicePageProfile.basicInfo.name);
  }

  protected renderPreview(email: Email): ReactElement {
    if (!email) {
      return <Typography>Fill in the required options to see a preview.</Typography>
    }
    return <iframe srcDoc={email.body} style={{minHeight: 840}} frameBorder={0}/>;
  }
}